AUI().ready(
    /*
	This function gets loaded when all the HTML, not including the portlets, is
	loaded.
	*/

    function () {}
);

Liferay.Portlet.ready(
    /*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/

    function (_portletId, _node) {}
);

Liferay.on(
    "allPortletsReady",

    /*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

    function () {
        // Search
        $(".search-icon-link").click(() => {
            $(".bootsnipp-search").toggleClass("d-flex");
            $(".js-nav-items").toggleClass("d-none");
        });

        // Mobile Accordion
        $(".accordion-link").click(function () {
            const accordionHref = $(this).attr("href");
            $(".tab-pane").removeClass("active show");
            $(accordionHref).addClass("active show");
            $(".nav-tabs .nav-item .nav-link").removeClass("active");
            $(`a[href*="${accordionHref}"`).addClass("active");
        });

        // Toggle Mobile Navigation Menu
        $("#menu-nav").click(() => {
            if (!$("#ag-mobile, #content").hasClass("show-nav"))
                $("#ag-mobile, #content").addClass("show-nav");
            else $("#ag-mobile, #content").removeClass("show-nav");
        });

        // Toggle Mobile Login Menu
        $("#login-nav, #js-login-back").click(() => {
            if (!$("#ag-mobile, #content").hasClass("show-login-nav"))
                $("#ag-mobile, #content").addClass("show-login-nav");
            else $("#ag-mobile, #content").removeClass("show-login-nav");
        });
    }
);
